/**
 * Created by Bowen on 28/08/2019.
 * Description:
 * change relationship type
 *
 * ------ maintenance history ------
 * Update by Marcus Zhao 2023/01/15 process special relationship type and use fix name.
 */

import { businessConstants } from '@tamalelibs/constants/business.constants';
import { EntityType } from './entity-type.model';
import { RelationshipType } from './relationship-type.model';

export class ValidRelationshipType {

    id: string;
    childEntityType: EntityType;
    parentEntityType: EntityType;
    relationshipType: RelationshipType;
    reciprocalRelationshipType: RelationshipType;
    editable?: boolean;
    deletable?: boolean;

    static parse(serverResponse): ValidRelationshipType {
        const result = new ValidRelationshipType();
        result.id = serverResponse['id'];
        result.childEntityType = EntityType.parseType(serverResponse['child-entity-type'].data);
        result.parentEntityType = EntityType.parseType(serverResponse['parent-entity-type'].data);
        result.relationshipType = RelationshipType.parse(serverResponse['relationship-type'].data);
        result.reciprocalRelationshipType = RelationshipType.parse(serverResponse['reciprocal-relationship-type'].data);
        result.deletable = serverResponse['deletable'];
        result.editable = serverResponse['editable'];

        if (result.parentEntityType.id && result.parentEntityType.id === businessConstants.EntityTypes.Contact_Id && result.childEntityType.id && result.childEntityType.id === businessConstants.EntityTypes.Contact_Id) {
            result.parentEntityType.name = businessConstants.EntityTypesName.contact_to_entity;
            result.childEntityType.name = businessConstants.EntityTypesName.entity_to_contact;
        }

        if (result.parentEntityType.id && result.parentEntityType.id === businessConstants.EntityTypes.Contact_To_Contact_Id && result.childEntityType.id && result.childEntityType.id === businessConstants.EntityTypes.Contact_To_Contact_Id) {
            result.parentEntityType.name = businessConstants.EntityTypesName.contact;
            result.childEntityType.name = businessConstants.EntityTypesName.contact;
        }

        if (result.relationshipType.id && result.relationshipType.id === businessConstants.RelationshipTypes.IS_IN_TEAM_ID) {
            result.childEntityType.name = businessConstants.EntityTypesName.entity_type_team_member;
        }

        if (result.relationshipType.id && result.relationshipType.id === businessConstants.RelationshipTypes.TOPIC_MEMBER_ID) {
            result.childEntityType.name = businessConstants.EntityTypesName.entity_type_topic_member;
            result.parentEntityType.name = businessConstants.EntityTypesName.entity_type_all;
        }

        return result;
    }
}
